module.exports = __webpack_public_path__ + "static/media/gb.5436d760.svg";